const RESOURCE_NAME = '/shipments-packages';
import restApi from "@/api/rest-api-object";

export default axios => ({
    ...restApi(axios, RESOURCE_NAME),
});